import { base } from '../base';

export const descriptiveAnalysis = `${base}/descriptiveanalysisreport`;
